import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import "./style.scss";

export const Loading = () => {
    return (
        <Grid container>
            <Grid
                size={{
                    xs: 12,
                    sm: 12,
                    md: 12,
                    lg: 12,
                    xl: 12,
                }}
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 9999,
                    top: "50%",

                    position: "absolute",
                }}
            >
                <CircularProgress size={100} variant="indeterminate" />
                <Typography
                    variant="body1"
                    color="primary"
                    sx={{
                        mt: 2,
                    }}
                >
                    Cargando...
                </Typography>
            </Grid>
        </Grid>
    );
};
